module.exports = __webpack_public_path__ + "static/fish-curve-1668235d59818ca282b0f9f005ad1a81.mp4";